module.exports = __webpack_public_path__ + "static/img/row3.7810ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row3.png
// module id = 8asQ
// module chunks = 12